export default "__VITE_ASSET__CAu6ctdk__"